/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { TurJobExecution } from '../../models/tur-job-execution';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface RestartJob$Params {
  jobId: string;
}

export function restartJob(
  http: HttpClient,
  rootUrl: string,
  params: RestartJob$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TurJobExecution>> {
  const rb = new RequestBuilder(rootUrl, restartJob.PATH, 'post');
  if (params) {
    rb.path('jobId', params.jobId, {});
  }

  return http.request(rb.build({ responseType: 'blob', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TurJobExecution>;
    }),
  );
}

restartJob.PATH = '/manage/job/{jobId}/restart';
